import { useApolloClient } from '@apollo/client';
import { isObject } from 'lodash';
import { useCallback } from 'react';
import { type CompanySpecsFragment } from '../../../api/fragments/CompanySpecs';
import { type UploadFileWithPreviewFormDataFragment } from '../../../api/fragments/UploadFileWithPreviewFormData';
import {
    DeleteEdmSocialMediaAssetDocument,
    type DeleteEdmSocialMediaAssetMutation,
    type DeleteEdmSocialMediaAssetMutationVariables,
} from '../../../api/mutations/deleteEdmSocialMediaAsset';
import {
    UploadEdmSocialMediaAssetDocument,
    type UploadEdmSocialMediaAssetMutation,
    type UploadEdmSocialMediaAssetMutationVariables,
} from '../../../api/mutations/uploadEdmSocialMediaAsset';
import { CompanyAsset } from '../../../api/types';

const useHandleEdmEmailSocialMediaAsset = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (
            socialMediaId: string,
            values: UploadFileWithPreviewFormDataFragment | File,
            initialValues?: CompanySpecsFragment
        ) => {
            const media = initialValues?.edmEmailFooter.socialMedia.find(list => list.id === socialMediaId);

            if (values instanceof File) {
                await apolloClient.mutate<
                    UploadEdmSocialMediaAssetMutation,
                    UploadEdmSocialMediaAssetMutationVariables
                >({
                    mutation: UploadEdmSocialMediaAssetDocument,
                    variables: { socialMediaId, type: CompanyAsset.Icon, upload: values },
                });
            } else if (values === null && isObject(media?.icon)) {
                await apolloClient.mutate<
                    DeleteEdmSocialMediaAssetMutation,
                    DeleteEdmSocialMediaAssetMutationVariables
                >({
                    mutation: DeleteEdmSocialMediaAssetDocument,
                    variables: { socialMediaId, type: CompanyAsset.Icon },
                });
            }
        },
        [apolloClient]
    );
};

export default useHandleEdmEmailSocialMediaAsset;
